import React, { useEffect, useState } from "react";
import PreviousMeetings from "../components/PreviousMeetings";
import axios from "axios";
import { Meeting } from "../../../shared/src/types/Meeting"; 
import { useUpdateMeetingMutation } from '../api/MeetingsApi';



const MeetingsPage: React.FC = () => {
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [updateMeeting, { isLoading: isUpdating }] = useUpdateMeetingMutation();

  const loadMeetings = async () => {
    try {
      const response = await axios.get("/api/meetings");
      setMeetings(response.data);
    } catch (error) {
      console.error("שגיאה בטעינת הפגישות:", error);
    }
  };
  
const handleUpdate = async (id: string, updatedData: Partial<Meeting>) => {
  try {
    await updateMeeting({ id, updatedData }).unwrap();
    alert('פגישה עודכנה בהצלחה');
    await loadMeetings();
  } catch (error) {
    console.error('שגיאה בעדכון הפגישה:', error);
    alert('שגיאה בעדכון הפגישה');
  }
};


  useEffect(() => {
    loadMeetings();
  }, []);

  return (
    
    <div>
      
      <h2>רשימת פגישות המעודכנת</h2>
      <PreviousMeetings
        meetings={meetings}
        refreshMeetings={loadMeetings}
        onUpdateMeeting={handleUpdate}  
      />
      {isUpdating && <div>מעדכן...</div>}
    </div>
  );
};

export default MeetingsPage;